fx.ns("filters", class SortPhotosFaces extends fx.Filter {

	constructor(data)
	{
		super(data);
		this.label = fx.text("Par visage");
	}

	exec()
	{
		return this.rawData;
	}	
});